// Glossary for consistent Hindi terminology across scheme pages and UI
export const glossaryHi: Record<string, string> = {
  // Section headings
  "Overview": "परिचय",
  "Objectives": "उद्देश्य",
  "Eligibility": "पात्रता",
  "Application Procedure": "आवेदन प्रक्रिया",
  "Publish Date": "प्रकाशन तिथि",
  "Funding Pattern": "वित्तपोषण पैटर्न",
  "Scheme History": "योजना का इतिहास",
  "Aim": "उद्देश्य",
  "Types of Development Works Covered": "आवृत विकास कार्यों के प्रकार",
  "Budget": "बजट",
  "Source": "स्रोत",
  "Duties and Functions": "कर्तव्यों और कार्य",
  // Additional common section titles seen across schemes
  "Scheme Brief": "योजना संक्षेप",
  "Launching of Scheme": "योजना का शुभारंभ",
  "Target Group": "लक्षित समूह",
  "Programme Strategy": "कार्यक्रम रणनीति",
  "Permissible Works": "अनुमेय कार्य",
  // Common UI labels
  "Scheme Details": "योजना विवरण",
  "Create": "निर्माण",
  "Manage": "प्रबंधन",
  "Rural Development Department | Haryana": "ग्रामीण विकास विभाग | हरियाणा",
  // Common terms
  "Village": "गाँव",
  "Block": "खण्ड",
  "District": "जिला",
  // Misc phrases often appearing in scheme content
  "Development": "विकास",
  "Infrastructure": "बुनियादी ढाँचा",
  "Employment": "रोजगार",
  // Administrative and technical roles/terms
  "Gram Panchayat": "ग्राम पंचायत",
  "Gram Sabha": "ग्राम सभा",
  "Panchayat Samiti": "पंचायत समिति",
  "Block Programme Officer": "खण्ड कार्यक्रम अधिकारी",
  "District Programme Coordinator": "जिला कार्यक्रम समन्वयक",
  "Job Card": "जॉब कार्ड",
  "Worksite Facilities": "कार्यस्थल सुविधाएँ",
  "Material component": "सामग्री घटक",
  "Wage seeker": "मजदूरी चाहने वाला",
  "Wage seekers": "मजदूरी चाहने वाले",
  "Unskilled manual work": "अकुशल हस्त श्रम",
  "Social audit": "सामाजिक अंकेक्षण",
  "Muster Roll": "मस्टर रोल",
  "Measurement Book": "मापन पुस्तिका",
  "Schedule of Rates": "दर सूची",
  "Financial year": "वित्तीय वर्ष",
  "Wage rate": "मजदूरी दर",
  "Asset creation": "संपत्ति निर्माण",
  "Knowledge Resource Centre": "ज्ञान संसाधन केंद्र",
}

export default glossaryHi